<template>
  <!-- 修改密码-->
  <div class="modify-pwd view-box">
    <navBan title="修改密码"></navBan>

    <p class="tip-info">密码长度 6~32 数字或字母组合，区分大小写</p>
    <div class="input-box" style="margin-top: 32px">
      <img class="icon" src="../../assets/images/password.svg" alt="">
      <input v-model="pwdState.newPassword" @change="pwdValidate(undefined, pwdState.newPassword)" placeholder="设置密码" type="password">
    </div>

    <div class="input-box">
      <img class="icon" src="../../assets/images/password.svg" alt="">
      <input v-model="pwdState.confirmPassword" @change="pwdValidate(undefined, pwdState.confirmPassword)" placeholder="确认密码" type="password">
    </div>

    <button @click="submitForm" class="button" :class="{ 'button-disabled': emptyForm }" :disabled="emptyForm">确认修改</button>
  </div>
</template>

<script setup>
import navBan from '@/components/navBan';
import { computed, onBeforeUnmount, onUnmounted, onMounted} from 'vue';
import { submitChangePwd, pwdState } from '@/utils/setup/handlePwd';
import { MobileLogOut } from '@/utils/setup/logOut';
import { Toast } from 'vant';
import { pwdValidate } from '@/utils/setup/pwdValidate';

let PlatForm = sessionStorage.getItem('PlatFormType');
let appType = sessionStorage.getItem('appType');

function agentFallback (e) {
  setTimeout(() => {
    window.history.go(-2);
  }, 200);
};
if (PlatForm == 2 || (PlatForm == 1 && appType == 1)) {
  window.addEventListener(
    'popstate',
    agentFallback,
    true
  );
}
onUnmounted(() => {
  if (PlatForm == 2 || (PlatForm == 1 && appType == 1)) {
    setTimeout(() => {
      window.removeEventListener('popstate', agentFallback, true);
    }, 1000);
  }
});

onBeforeUnmount(() => {
  pwdState.newPassword = '';
  pwdState.confirmPassword = '';
});
const emptyForm = computed(() => {
  return pwdState.newPassword === '' || pwdState.confirmPassword === '';
});

async function submitForm () {
  if (!pwdValidate(undefined, pwdState.newPassword)) { return; }
  if (!pwdValidate(undefined, pwdState.confirmPassword)) { return; }
  if (pwdState.confirmPassword !== pwdState.newPassword) {
    Toast('两次密码不一致');
    return false;
  }

  await submitChangePwd();
  Toast('修改成功');
  await MobileLogOut();
}
</script>

<style lang="scss" scoped>
.view-box{padding-top:1px;}
.modify-pwd {
}
</style>
